import { render } from "./VideoFull.vue?vue&type=template&id=08d90ea3"
import script from "./VideoFull.vue?vue&type=script&lang=js"
export * from "./VideoFull.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__